import LinearLoading from '@/components/linear-loading';
import { useDialog } from '@/contexts/DialogContext';
import InMemoryFileDownloadService from '@/services/InMemoryFileDownloadService.service';
import { PlanService } from '@/services/Plan.service';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { FilePreview } from './FilePreview';

type DocumentPreviewDialogProps = {
  sponsorPlanId: number;
  documentId: number;
  documentKey: string;
  fileName: string;
};

export const DocumentPreviewDialog: React.FC<DocumentPreviewDialogProps> = (
  props: DocumentPreviewDialogProps
) => {
  const { closeDialog } = useDialog();

  const { data, isLoading } = useQuery(
    ['PlanService.getDocumentForPlanId', props.sponsorPlanId, props.documentId],
    () =>
      PlanService.getDocumentForPlanId(props.sponsorPlanId, props.documentId),
    { enabled: !!props.documentId }
  );

  return (
    <>
      <DialogTitle>
        {props.documentKey} - {props.fileName}
      </DialogTitle>
      <DialogContent
        data-testid={`dialog-content-document-preview-${props.documentId}`}
        style={{ padding: '25px' }}>
        {isLoading && <LinearLoading />}
        {!isLoading && data?.originalFileName && data?.base64Data && (
          <FilePreview
            base64Data={data.base64Data}
            originalFileName={data.originalFileName}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button data-testid='cancel-btn' onClick={closeDialog} variant='text'>
          CLOSE
        </Button>
        <Button
          data-testid='download-btn'
          onClick={() =>
            InMemoryFileDownloadService.triggerFileDownload(
              data.base64Data,
              data.originalFileName
            )
          }
          variant='contained'>
          DOWNLOAD
        </Button>
      </DialogActions>
    </>
  );
};
